<template>
	<div class="editor">
		<table class="simple-table">
			<tbody>
				<tr>
					<th>홈 > 인기 신제품</th>
					<td>
						<RadioList v-model="isHome" :radioList="radioList" />
					</td>
				</tr>
				<tr>
					<th>홈 > 인기 신제품 랭킹 상단</th>
					<td>
						<RadioList v-model="isMonth" :radioList="radioList" />
					</td>
				</tr>
				<tr>
					<th>탐색 하단 (소재 A)</th>
					<td>
						<RadioList
							v-model="isFirstCategory"
							:radioList="radioList"
						/>
						<p>
							* 카테고리와 무관하게 2차카테고리 목록 하단에
							랜덤으로 1개의 배너를 보여줍니다.
						</p>
					</td>
				</tr>
				<tr>
					<th>제품 상세 (소재 B)</th>
					<td>
						<RadioList
							v-model="isProduct"
							:radioList="statusList"
						/>
						<label class="editor__label">
							<input v-model="displayBrandId" type="checkbox" />
							<span class="editor__label__span">
								동일 브랜드 제품에서 노출
							</span>
						</label>
					</td>
				</tr>
			</tbody>
		</table>
		<table class="simple-table">
			<tbody>
				<tr>
					<th colspan="1">제품</th>
					<td colspan="3" class="editor__product-search">
						<product-selector
							v-model="idProduct"
							@change="onProductChange"
						/>
					</td>
				</tr>
				<tr>
					<th>광고기간</th>
					<td colspan="3">
						<form
							id="monthly-product-editor-date-range"
							@submit.prevent="onSubmit"
						>
							<DateRange v-model="datePeriod" />
							<p>
								* 정각마다 데이터가 갱신되기에 시작시간은 00분
								종료시간은 59분으로 설정해야 하며 수동으로
								갱신을 원할시 수정을 한번 해주세요.
							</p>
						</form>
					</td>
				</tr>
				<tr>
					<th>광고소재 A</th>
					<td class="editor__ad-image">
						<image-uploader
							group="monthly"
							ref="image1"
							:image-size-limit="{
								width: 9999,
								height: 9999,
								previewWidth: 200,
								type: 'max',
							}"
							@upload="onImageUpload($event, 'image1')"
							@cancel="onImageCancel"
						/>
					</td>
					<th>광고소재 B</th>
					<td class="editor__ad-image">
						<image-uploader
							group="monthly"
							ref="image2"
							:image-size-limit="{
								width: 9999,
								height: 9999,
								previewWidth: 200,
								type: 'max',
							}"
							@upload="onImageUpload($event, 'image2')"
							@cancel="onImageCancel"
						/>
					</td>
				</tr>
				<tr>
					<th>링크종류</th>
					<td>
						<select-box-v2
							v-model="linkType"
							:options="getLinkTypeList"
							placeholder="링크종류를 선택하세요"
							:box-style="{
								height: '200px',
								overflow: 'scroll',
								top: 'initial',
								bottom: 'calc(100% + 5px)',
								'z-index': 999999,
							}"
						/>
					</td>
					<th>링크값</th>
					<td>
						<input
							aria-label="링크값"
							type="text"
							v-model="linkValue"
							placeholder="링크값"
						/>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="editor__buttons">
			<button
				type="button"
				class="editor__buttons__button btn-main blue bordered"
				v-text="'다시작성'"
				@click="onCancel"
			/>
			<button
				form="monthly-product-editor-date-range"
				type="submit"
				class="editor__buttons__button btn-main blue"
				v-text="mode === 'register' ? '등록' : '수정'"
			/>
		</div>
	</div>
</template>
<script>
	import moment from 'moment';
	import { imageRemove } from '@/util';
	import Validator from '@/Validator';
	import RadioList from '@/components/RadioList';
	import DateRange from '@/components/DateRange';
	import ImageUploader from '@/components/ImageUploader';
	import SelectBoxV2 from '@/components/SelectBoxV2';
	import ProductSelector from '@/components/ProductSelector';

	export default {
		name: 'MonthlyProductEditor',
		components: {
			RadioList,
			DateRange,
			ImageUploader,
			SelectBoxV2,
			ProductSelector,
		},
		props: {
			mode: {
				type: String,
				default: 'register',
			},
			itemId: {
				type: Number,
				default: null,
			},
		},
		data() {
			return {
				isHome: 0,
				isMonth: 0,
				isFirstCategory: 0,
				isProduct: 0,
				displayBrandId: false,
				radioList: [
					{ id: 0, value: '비전시' },
					{ id: 1, value: '제품링크' },
					{ id: 2, value: '광고링크' },
				],
				statusList: [
					{ id: 0, value: '비전시' },
					{ id: 1, value: '광고링크' },
				],
				idBrand: null,
				idProduct: null,
				brandTitle: '',
				productTitle: '',
				datePeriod: { from: '', to: '' },
				image1: null,
				image2: null,
				linkType: null,
				linkValue: null,
			};
		},
		computed: {
			getLinkTypeList() {
				return this.$store.state.filter.newLinkTypeList.map(
					linkType => {
						return {
							label: linkType.name,
							value: linkType.id,
						};
					}
				);
			},
		},
		watch: {
			mode(value) {
				if (value === 'edit') {
					this.setProductData();
				}
			},
		},
		methods: {
			validation() {
				const rules = {
					idProduct: {
						data: this.idProduct,
						label: '제품',
						rules: ['required'],
						customMessages: {
							required: {
								message: '$LABEL 선택해 주세요',
								josa: '을를',
							},
						},
					},
					startDate: {
						data: this.datePeriod.from,
						label: '광고 시작 기간',
						rules: ['required'],
					},
					endDate: {
						data: this.datePeriod.to,
						label: '광고 종료 기간',
						rules: ['required'],
					},
					image1: {
						data: this.image1,
						label: '광고소재A',
						rules: ['required'],
					},
					linkType: {
						data: this.linkType,
						label: '링크타입',
						rules: ['required'],
					},
					linkValue: {
						data: this.linkValue,
						label: '링크값',
						rules: ['required'],
					},
				};

				const validator = new Validator(rules);
				validator.run();

				return validator;
			},
			setProductData() {
				this.$axiosAdmin2
					.get(`/api/products/monthly/${this.itemId}`)
					.then(({ data }) => {
						const imageHost = `${this.$store.state.env.IMAGE_STORAGE_PATH}`;

						this.isHome = data.isHome;
						this.isMonth = data.isMonth;
						this.isFirstCategory = data.isFirstCategory;
						this.isProduct = data.isProduct ? 1 : 0;
						this.displayBrandId = data.displayBrandId !== null;
						this.linkType = data.linkType;
						this.linkValue = data.linkValue;
						this.datePeriod = {
							from: moment(data.startDate, 'YYYYMMDDhhmm').format(
								'YYYY-MM-DDTHH:mm'
							),
							to: moment(data.endDate, 'YYYYMMDDhhmm').format(
								'YYYY-MM-DDTHH:mm'
							),
						};
						this.idProduct = data.idProduct;

						this.image1 = `${data.fileDir1}/${data.fileSaveName1}`;
						this.$refs.image1.setImageByUrl(
							`${imageHost}${data.fileDir1}/${data.fileSaveName1}`
						);

						if (data.fileDir2 && data.fileSaveName2) {
							this.image2 = `${data.fileDir2}/${data.fileSaveName2}`;
							this.$refs.image2.setImageByUrl(
								`${imageHost}${data.fileDir2}/${data.fileSaveName2}`
							);
						}
					})
					.catch(err => {
						console.error(err);
					});
			},
			formInit() {
				this.isHome = 0;
				this.isMonth = 0;
				this.isFirstCategory = 0;
				this.isProduct = 0;
				this.displayBrandId = false;
				this.idBrand = null;
				this.idProduct = null;
				this.brandTitle = '';
				this.productTitle = '';
				this.datePeriod = { from: '', to: '' };
				this.image1 = null;
				this.image2 = null;
				this.linkType = null;
				this.linkValue = null;

				this.$refs.image1.cancelImage();
				this.$refs.image2.cancelImage();
			},
			onProductChange(product) {
				if (product) {
					this.idProduct = product.idProduct;
					this.idBrand = product.idBrand;
					this.productTitle = product.productTitle;
					this.brandTitle = product.brandTitle;
				} else {
					this.idProduct = null;
					this.productTitle = '';
					this.brandTitle = '';
				}
			},
			onImageUpload({ fileDir, fileSaveName }, target) {
				if (fileDir && fileSaveName) {
					this[target] = `${fileDir}/${fileSaveName}`;
				} else {
					this[target] = null;
				}
			},
			onImageCancel(key) {
				if (this.mode === 'register') {
					imageRemove(key);
				}
			},
			onSubmit() {
				const validation = this.validation();

				if (!validation.isValid) {
					alert(validation.getFirstErrorMessage());
					return false;
				}

				const image1Array = this.image1.split('/');
				const [fileDir1, fileSaveName1] = [
					image1Array.splice(0, image1Array.length - 1).join('/'),
					image1Array.pop(),
				];
				let image2Array;
				let fileDir2, fileSaveName2;

				if (this.image2) {
					image2Array = this.image2.split('/');
					[fileDir2, fileSaveName2] = [
						image2Array.splice(0, image2Array.length - 1).join('/'),
						image2Array.pop(),
					];
				} else {
					[fileDir2, fileSaveName2] = [null, null];
				}

				this.$emit('submit', {
					fileDir1,
					fileDir2,
					fileSaveName1,
					fileSaveName2,
					isHome: this.isHome,
					isMonth: this.isMonth,
					isFirstCategory: this.isFirstCategory,
					isProduct: this.isProduct === 1,
					idProduct: this.idProduct,
					displayBrandId: this.displayBrandId ? this.idBrand : null,
					brandTitle: this.brandTitle,
					productTitle: this.productTitle,
					startDate: this.datePeriod.from.replace('T', ' '),
					endDate: this.datePeriod.to.replace('T', ' '),
					linkType: this.linkType,
					linkValue: this.linkValue,
				});
			},
			onCancel() {
				if (this.mode === 'register') {
					this.formInit();
				} else {
					this.setProductData();
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.simple-table {
		background: #fff;
		margin: 1em 0 2em;
	}

	.radio {
		margin-bottom: 0.5em;
	}

	.period-input-box {
		height: 72px;
	}

	.select-box {
		width: 100%;
	}

	.editor__label {
		cursor: pointer;
	}

	.editor__label__span {
		vertical-align: text-top;
	}

	.editor__ad-image {
		text-align: center;
	}

	.editor__buttons {
		text-align: center;
	}
</style>
